import { render, staticRenderFns } from "./delivery-grid.vue?vue&type=template&id=6a40a40d&scoped=true"
import script from "./delivery-grid.vue?vue&type=script&lang=js"
export * from "./delivery-grid.vue?vue&type=script&lang=js"
import style0 from "./delivery-grid.vue?vue&type=style&index=0&id=6a40a40d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a40a40d",
  null
  
)

export default component.exports